<div class="row border-bottom pb-2 arabic-dir">
  <h5 class="text-primary text-left col-8">
    {{ "BAZZAR.ADD_NEW_ADDRESS" | translate }}
  </h5>
  <i
    class="fa fa-times text-left-ar text-dark text-right col-4 pt-1"
    (click)="onNoClick()"
  >
  </i>
</div>
<div>
  <form action="" class="mt-4 px-2" [formGroup]="addAddressForm">
    <div class="row mb-2 mx-0">
      <small class="text-muted text-left">
        {{ "BAZZAR.CONTACT_DETAILS" | translate }}
      </small>
    </div>
    <div class="row mx-0 text-left">
      <div class="form-group col-md-6 px-0" dir="ltr">
        <input
          dir="ltr"
          type="tel"
          ng2TelInput
          pattern="[0-9]*"
          [ng2TelInputOptions]="{ initialCountry: 'jo' }"
          class="form-control"
          formControlName="phone"
          placeholder="{{ 'BAZZAR.MOBILE_NUMBER' | translate }}"
          required
          maxlength="15"
        />
        <br />
        <mat-error *ngIf="addAddressForm.controls.phone.hasError('pattern')">
          {{ "BAZZAR.PHONE_PATTERN" | translate }}
        </mat-error>

        <mat-error
          *ngIf="
            addAddressForm.controls.phone.errors?.required &&
            addAddressForm.controls.phone.touched
          "
        >
          {{ "BAZZAR.REQUIRED" | translate }}
        </mat-error>
      </div>
    </div>
    <div class="row mb-2 mt-3 mx-0 text-left px-0">
      <small class="text-muted text-left">
        {{ "BAZZAR.ADDRESS_DETAILS" | translate }}
      </small>
    </div>
    <div class="row mx-0 px-0">
      <div class="form-group col-md-6 pl-0 pr-1">
        <input
          type="text"
          formControlName="country"
          class="form-control"
          disabled
          required
          value="Jordan"
          placeholder="{{ 'BAZZAR.COUNTRY' | translate }}"
        />

        <mat-error
          *ngIf="
            addAddressForm.controls.country.errors?.required &&
            addAddressForm.controls.country.touched
          "
        >
          {{ "BAZZAR.REQUIRED" | translate }}
        </mat-error>
      </div>
      <div class="form-group col-md-6 pr-1 pl-0">
        <select
          formControlName="city"
          required
          type="text"
          class="form-control"
        >
          <option selected>- {{ "BAZZAR.SELECT" | translate }} -</option>
          <option value="irbid">
            {{ "BAZZAR.IRBID" | translate }}
          </option>
          <option value="amman">
            {{ "BAZZAR.AMMAN" | translate }}
          </option>
          <option value="jarash">
            {{ "BAZZAR.JARASH" | translate }}
          </option>
          <option value="ajloon">
            {{ "BAZZAR.AJLOON" | translate }}
          </option>
          <option value="mafraq">
            {{ "BAZZAR.MAFRAQ" | translate }}
          </option>
          <option value="madaba">
            {{ "BAZZAR.MADABA" | translate }}
          </option>
          <option value="zarqa">
            {{ "BAZZAR.ZARQA" | translate }}
          </option>
          <option value="aqaba">
            {{ "BAZZAR.BALQAA" | translate }}
          </option>

          <option value="karak">
            {{ "BAZZAR.KARAK" | translate }}
          </option>
          <option value="tafela">
            {{ "BAZZAR.TAFELA" | translate }}
          </option>
          <option value="maan">{{ "BAZZAR.MAAN" | translate }}</option>
          <option value="aqaba">
            {{ "BAZZAR.AQABA" | translate }}
          </option>
        </select>
        <mat-error
          *ngIf="
            addAddressForm.controls.city.errors?.required &&
            addAddressForm.controls.city.touched
          "
        >
          {{ "BAZZAR.REQUIRED" | translate }}
        </mat-error>
      </div>
    </div>

    <div class="row mx-0 px-0">
      <div class="form-group col-md-12 px-0 pl-0">
        <input
          class="form-control"
          maxlength="500"
          formControlName="addressLineOne"
          placeholder="{{ 'BAZZAR.ADDRESS_DETAILS' | translate }}"
        />
        <mat-error
          *ngIf="
            addAddressForm.controls.addressLineOne.errors?.required &&
            addAddressForm.controls.addressLineOne.touched
          "
        >
          {{ "BAZZAR.REQUIRED" | translate }}
        </mat-error>
      </div>
    </div>
    <div class="row mx-0 px-0">
      <div class="form-group col-md-12 px-0">
        <input
          maxlength="500"
          class="form-control"
          formControlName="addressLineTwo"
          placeholder="{{ 'BAZZAR.ADDITIONAL_DIRECTIONS' | translate }}"
        />
      </div>
    </div>
  </form>

  <div class="text-right mt-4 text-left-ar">
    <button class="btn btn-outline-success mx-1" (click)="onNoClick()">
      {{ "BAZZAR.CANCEL" | translate }}
    </button>
    <button class="btn btn-success mx-1">
      {{ "BAZZAR.CONFIRM" | translate }}
    </button>
  </div>
</div>
